import type { GroupMember } from './property-group';

/**
 * Ajoute plusieurs biens aux membres d'un immeuble en UNE écriture.
 * Ajouter les biens un par un, en parallèle, relisait chaque fois la même liste
 * et ne gardait que le dernier (audit « cas Bruphils », 5 biens cochés → 1 ajouté).
 * Les doublons, et les biens déjà membres, sont ignorés.
 */
export function withAddedProperties(
  members: readonly GroupMember[],
  propertyIds: readonly string[],
  now: Date = new Date()
): { members: GroupMember[]; added: string[] } {
  const present = new Set(members.filter(m => m.type === 'property').map(m => m.id));
  const added: string[] = [];
  for (const id of propertyIds) {
    if (!id || present.has(id)) continue;
    present.add(id);
    added.push(id);
  }
  return {
    members: [...members, ...added.map(id => ({ id, type: 'property' as const, addedAt: now }))],
    added
  };
}
